import './SeverityBadge.css';

const LABELS = {
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    info: 'Info',
};

export default function SeverityBadge({ severity }) {
    const label = LABELS[severity];
    if (!label) return null;
    return (
        <span className={`severity-badge severity-badge--${severity}`}>
            {label}
        </span>
    );
}
